/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-11 11:19:38
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-13 18:03:27
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductEditor/Components/SalesChannelAvailablity/ProductTable.tsx
 */
import React from 'react';
import css from './css.module.less';
import EditableTable from 'src/components/Antd/Table/SizeFittingTable';
import Tooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';

import { EnumTablePosition } from 'src/types/common/common';
import { expandsWidth } from 'src/tools/constant';
import Link from 'src/components/Link/GreenLink';
import { unlinkProduct } from 'src/request/product/product';
import { msg } from '@/src/tools/message';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import Warning from '@/src/components/Antd/Modal/WarningModal';
const ExpandTable = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    keyProps,
    data, //parentIndex, onChange
    productUuid,
    onDelete,
    salesChannelUuid,
    disabled,
  } = props;
  const [unlinkUuid, setunlinkUuid] = React.useState(null);
  const handleConfirmUnlink = () => {
    if (!unlinkUuid) return;

    unlinkProduct(productUuid, unlinkUuid).then((res) => {
      if (onDelete) {
        onDelete({ salesChannelUuid, productUuid: unlinkUuid });
        msg.success(
          getI18n('allProducts.addproductset.producthasbeenunlinked'),
        );
      }
      setunlinkUuid(null);
    });
  };
  const col = [
    {
      key: 'expand',
      childGenerate: (text, record, index) => {
        return <React.Fragment />;
      },
      width: expandsWidth,
      default: true,
    },
    {
      key: 'icon',
      childGenerate: (text, record, index) => {
        return <React.Fragment />;
      },
      width: 88,
      default: true,
    },
    {
      childGenerate: (text, record, index) => {
        const { productName, thumbnailUrl } = record;
        return (
          <NoWrapContainer>
            <Tooltip title={productName}>
              <img className={css.productImg} src={thumbnailUrl} />
              {productName}
            </Tooltip>
          </NoWrapContainer>
        );
      },
      key: 'productName',
      minWidth: 503,
      default: true,
    },
    {
      title: getI18n('general.type'),
      childGenerate: (text, record, index) => {
        return <React.Fragment />;
      },
      key: 'ProductType',
      minWidth: 400,
      default: true,
    },
    {
      title: <React.Fragment />,
      position: EnumTablePosition.mid,

      childGenerate: (text, record, index) => {
        const { uuid } = record;
        return (
          <Actions
            disabled={disabled}
            onViewUrl={`/salesChannel/products/link/${salesChannelUuid}/${uuid}`}
            onUnlink={() => {
              setunlinkUuid(uuid);
            }}
          />
        );
      },
      key: 'ProductActions',
      width: 180,
      default: true,
    },
  ];

  return (
    <div className={css.expandContainer}>
      <EditableTable
        rowKey={'uuid'}
        showHeader={false}
        pagination={false}
        rowClassName={css.tableRowClassName}
        dataSource={data}
        columns={col}
        id={`ProductSetPriceAdvancedSetting${keyProps}`}
      />
      <Warning
        visible={!!unlinkUuid}
        header={getI18n('allProducts.addproductset.unlinkproduct')}
        onOk={handleConfirmUnlink}
        okText={getI18n('general.unlink')}
        cancelText={getI18n('general.cancel')}
        onCancel={() => setunlinkUuid(null)}>
        {getI18n('allProducts.addproductset.unlinkproductContent')}
      </Warning>
    </div>
  );
};
export default ExpandTable;

const Actions = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { onViewUrl, onUnlink, disabled } = props;
  return (
    <div className={css.container}>
      <Link className={css.view} to={onViewUrl}>
        {getI18n('general.view')}
      </Link>
      {!disabled && (
        <div className={css.unlink} onClick={onUnlink}>
          {getI18n('general.unlink')}
        </div>
      )}
    </div>
  );
};
